const CategoriesListing = () => import('../../components/Tenant/Category/List')
const CategoriesManage = () => import('../../components/Tenant/Category/Manage')

export default {
    path: 'tenant-categories',
    redirect: 'tenant-categories',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tenant-categories',
    meta: {'permissions': 'view-tenant-categories'},
    children: [
        {
            path: '/',
            component: CategoriesListing,
        },
        {
            path: 'create',
            name: 'create-tenant-category',
            meta: {'permissions': 'create-tenant-category'},
            component: CategoriesManage,
        },
        {
            path: 'update/:id',
            name: 'update-tenant-category',
            meta: {'permissions': 'update-tenant-category'},
            component: CategoriesManage,
        },
    ],
};
